'use client';

import { Suspense, useEffect } from 'react';
import PublicAuthProvider from 'src/app/_components/Providers/PublicAuthProvider';
import Header from 'src/app/(default)/_components/_common/Header';
import { cn } from 'src/app/lib/utils/tailwindcss';

import Footer from '@/app/_components/Footer';

import { FAB } from './FAB';

interface ClientLayoutProps {
  children: React.ReactNode;
}

export function ClientLayout({ children }: ClientLayoutProps) {
  useEffect(() => {
    const html = document.querySelector('html');
    const body = document.querySelector('body');

    if (!html) return;
    html.style.setProperty('scrollbar-width', 'none');

    if (!body) return;
    body.style.backgroundColor = '#0d0a17';

    return () => {
      html.style.setProperty('scrollbar-width', 'auto');
      body.style.backgroundColor = 'unset';
    };
  }, []);

  return (
    <Suspense fallback={null}>
      <PublicAuthProvider>
        <div className="h-full w-full bg-[#0d0a17]">
          <div
            className={cn(
              'relative z-0 mx-auto flex min-h-dvh w-full max-w-[480px] flex-1 flex-col items-center bg-white',
              'before:fixed before:top-0 before:left-1/2 before:z-9999 before:hidden before:h-full before:w-px before:-translate-x-[240px] before:bg-g-70 before:content-[""]',
              'after:fixed after:top-0 after:right-1/2 after:z-9999 after:hidden after:h-full after:w-px after:translate-x-[240px] after:bg-g-70 after:content-[""]',
              'sm:before:block sm:after:block',
            )}
          >
            <Header />
            <main className="mt-[56px] flex min-h-full w-full flex-1 flex-col overflow-x-hidden" role="main">
              {children}
            </main>
            <FAB />
            <Footer />
          </div>
        </div>
      </PublicAuthProvider>
    </Suspense>
  );
}
